import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const getTimeStandardsDwData = (organizationCode, state, setState) => {
  if (organizationCode) {
    const newState = {
      ...state,
      organizationCode
    };

    const api = initApi(API_NAMES.TIMES, newState, setState);
    const organizationCodeForUrl = encodeURIComponent(organizationCode);
    const url = `/TimeStandard/Organization/${organizationCodeForUrl}/Dw`;

    return api?.executeArray ? api.executeArray(url, 'GET') : null;
  }
};

const INITIAL_TIME_STANDARDS_DW_STATE = {
  ...BASIC_INITIAL_STATE,
  organizationCode: '',
  areOptionsLoaded: false,
  options: []
};

const TimeStandardsDwData = {
  INITIAL_TIME_STANDARDS_DW_STATE,
  getTimeStandardsDwData
};

export default TimeStandardsDwData;